module.exports = __webpack_public_path__ + "static/media/mark-completed-active.703b2194.svg";